module.exports = __webpack_public_path__ + "static/media/apartment10.8374c59a.jpg";